import type { ThemeOptions } from '@mui/material/styles';

export const createThemeOptions = (themeColor: string): ThemeOptions => ({
  palette: {
    primary: {
      main: themeColor
    },
    contrastThreshold: 2.1
  },
  typography: {
    fontFamily: 'inherit'
  }
});

export const RESPONSIVE_MARGIN = {
  xs: 2,
  sm: 4
};
